// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterForm__hgroup":"ou_a bib_a bib_x","FilterForm__vgroup":"ou_b bib_sv"};